import { createContext, useContext } from 'react';

export interface QueryParamsContextType {
  memberCardNumber: string;
  legacyAccountId: string;
  clientType: string;
  countryParam: string;
  locationNumber: string;
  userId: string;
  linkId: string;
}

export const QueryParamsContext = createContext<QueryParamsContextType | undefined>(undefined);

export function useQueryParamsContext() {
  const ctx = useContext(QueryParamsContext);
  if (!ctx) throw new Error('useQueryParamsContext must be used within QueryParamsProvider');
  return ctx;
}
